import type { EditorConfig } from "@prismicio/editor-fields"
import { captureException } from "@sentry/react"

import { env } from "./env"
import { getBaseUrl, getRepositoryName } from "./routing"
import { baseUrl as coreApiBaseUrl } from "./services/core"
import { trackEditorEvent } from "./services/tracking"

export const staticEditorConfig = {
  embedApiEndpoint: env.PRISMIC_EMBED_API_ENDPOINT,
  unsplashApiBaseUrl: env.PRISMIC_UNSPLASH_API_BASE_URL,
  mediaLibrary: true,
  assetsApiBaseUrl: env.PRISMIC_ASSETS_API_BASE_URL,
  repository: getRepositoryName(),
  searchDocuments: true,
  documentSearchBaseUrl: env.PRISMIC_DOCUMENT_SEARCH_BASE_URL,
  uidField: true,
  coreApiBaseUrl,
  customTypesApiBaseUrl: env.PRISMIC_CUSTOM_TYPES_API_BASE_URL,
  authStrategy: env.PRISMIC_PAGE_BUILDER_AUTH_STRATEGY,
  baseUrl: getBaseUrl(),
  integrationFields: true,
  integrationFieldsApiBaseUrl: env.PRISMIC_INTEGRATION_FIELDS_API_BASE_URL,
  scrollOffsetTop: 135,
  userServiceBaseUrl: env.PRISMIC_USER_SERVICE_BASE_URL,

  onAnalyticsEvent: trackEditorEvent,
  onTrackError: captureException,
} satisfies Partial<EditorConfig>
